import { WitaConnector } from '@/services/repository/connector'
import { querySerializer } from '@/utils/helpers/URLs'

import {
  AddChamadoProdutoParams,
  AddChamadoProdutoResponse,
  CreateChamadoProdutoParams,
  CreateChamadoProdutoResponse,
  RemoveChamadoProdutoParams,
  RemoveChamadoProdutoResponse,
  SearchChamadoProdutosParams,
  SearchChamadoProdutosResponse,
} from '../domain/chamado-produto'

const ROOT_URL = '/entity/call-product'

export const ChamadoProdutoService = {
  search: async (params: SearchChamadoProdutosParams) => {
    const url = ROOT_URL + `?${querySerializer(params)}`
    return await WitaConnector.get<SearchChamadoProdutosResponse>(url)
  },

  create: async (params: CreateChamadoProdutoParams) => {
    const url = ROOT_URL
    return await WitaConnector.post<CreateChamadoProdutoResponse>(url, params)
  },

  add: async ({ id }: AddChamadoProdutoParams) => {
    const url = ROOT_URL + `/${id}/add`
    return await WitaConnector.put<AddChamadoProdutoResponse>(url, null)
  },

  remove: async ({ id }: RemoveChamadoProdutoParams) => {
    const url = ROOT_URL + `/${id}/remove`
    return await WitaConnector.put<RemoveChamadoProdutoResponse>(url, null)
  },
}
